import React, { useEffect, useState } from 'react';
import AdminLayout from '../../../components/layout/AdminLayout';
import ExerciseSpecificForm from '../../../components/forms/ExerciseSpecificForm';
import { useExerciseSpecificApi } from '../../../hooks/useExerciseSpecificApi';
import { useNavigate, useParams } from 'react-router-dom';
import Card from '../../../components/common/Card';
import { ExerciseSpecificDTO } from '../../../services/apiClient';

const ExerciseSpecificEdit: React.FC = () => {
  const { getById, edit, isLoading } = useExerciseSpecificApi();
  const [entityData, setEntityData] = useState<ExerciseSpecificDTO | null>(null);
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  const breadcrumbs = [
    { label: 'Admin', href: '#' },
    { label: 'Exercise Specifics', href: '/admin/exercisespecifics' },
    { label: 'Edit', href: '#' },
  ];

  useEffect(() => {
    const fetchEntityData = async () => {
      try {
        const response = await getById(id!);
        setEntityData(response?.data || null);
      } catch (error) {
        console.error('Error fetching Exercise Specific data:', error);
      }
    };

    fetchEntityData();
  }, [id]);

  const handleSubmit = async (data: any) => {
    try {
      await edit(id!, data);
      navigate('/admin/exercisespecifics');
    } catch (error) {
      console.error('Error updating Exercise Specific:', error);
    }
  };

  return (
    <AdminLayout
      activeMenuItem="/admin/exercisespecifics"
      breadcrumbs={breadcrumbs}
      allowedRoles={['Admin']}
      requiredPermission='Settings.ExerciseSpecific.Edit'
    >
        {entityData ? (
          <ExerciseSpecificForm
            initialValues={entityData}
            onSubmit={handleSubmit}
            onCancel={() => navigate('/admin/exercisespecifics')}
          />
        ) : (
          <p>Loading...</p>
        )}
    </AdminLayout>
  );
};

export default ExerciseSpecificEdit;